<template>
  <div class="service">
    <div class="fz14 bold fr ac jsb">
      <span>服务订单</span>
    </div>

    <div class="mt30">
      <el-tabs v-model="tab">
        <el-tab-pane label="所有订单" nam="0"></el-tab-pane>
        <el-tab-pane label="待完成" name="1"></el-tab-pane>
        <el-tab-pane label="已完成" name="2"></el-tab-pane>
      </el-tabs>

      <!-- 搜索 -->

      <div>
        <el-input style="width: 336px" placeholder="请输入商品名称或订单号" size="mini"></el-input>

        <el-button class="ml20" type="primary" size="mini">搜索</el-button>
      </div>

      <div class="info_box">
        <div class="fr ac fz12 mt30">
          <div class="center order_list_item">产品信息</div>
          <div class="center order_list_item">状态</div>
          <div class="center order_list_item">日期</div>
          <div class="center order_list_item">价格</div>
          <div class="center fg">操作</div>
        </div>

        <el-divider/>

        <!--        列表-->

        <div class="order-list fz12">
          <div class="order-item mt20" v-for="(item,index) in service_list" :key="index">
            <!--                上-->
            <div class="top fr ac">
              <p class="ml10">订单号:{{ item.order_no }}</p>
            </div>
            <!--                中-->

            <div class="fr middle">
              <!-- 商品信息 -->
              <div class="order">
                <div class="fr order_left">
                  <div class="fr ac jc order_list_item">
                    <p class>【{{ item.type_name }}/{{ item.level_name }}】</p>
                  </div>
                  <div class="center order_list_item" v-html="order_state_decide(item)"></div>
                  <div class="center order_list_item">{{ item.create_time }}</div>
                  <div class="center order_list_item">￥{{ item.order_actual_price }}</div>
                </div>
              </div>
              <!-- 操作 -->
              <div class="fc jc ac fg fs operating pl10 pr10 pt10 pb10">
                <p
                    class="mt10 cursor grey"
                    @click="go(`/techniciandetail?id=${item.order_id}`)"
                >查看详情</p>
              </div>
            </div>
          </div>
        </div>
        <div class="fr ac jc">
          <el-pagination
              :hide-on-single-page="true"
              class="mt20 mb20"
              layout="prev, pager, next"
              :current-page.sync="page"
              :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// type == "sales" 为销售订单 else 客户订单
export default {
  props: {},
  data() {
    return {
      type: this.$route.query.type,
      tab: "0",
      order_state: "",
      page: 1,
      total: 0,
      service_list: []
    };
  },
  mounted() {
    this.getTechnicianOrders();
  },
  watch: {
    page(n) {
      this.getTechnicianOrders();
    },
    tab(n) {
      if (n === '0') {
        this.order_state = "";
      } else {
        this.order_state = n;
      }
      this.getTechnicianOrders();
    }
  },
  methods: {
    // 技术-获取订单列表
    getTechnicianOrders() {
      let param = {
        platform_sale_check_state: "",
        contract_check_state: "",
        technician_assign_state: "",
        pay_state: "",
        assessment_state: "",
        page: this.page
      }
      switch (this.tab) {
        case '0':
          param.platform_sale_check_state = "";
          param.contract_check_state = "";
          param.technician_assign_state = "";
          param.pay_state = "";
          param.assessment_state = "";
          break;
        case '1':
          param.platform_sale_check_state = "1";
          param.contract_check_state = "1";
          param.technician_assign_state = "";
          param.pay_state = "0";
          param.assessment_state = "";
          break;
        case '2':
          param.platform_sale_check_state = "1";
          param.contract_check_state = "1";
          param.technician_assign_state = "1";
          param.pay_state = "1";
          param.assessment_state = "1";
          break;
      }
      this.post(this.$store.getters.getServiceOrderList, param).then(res => {
        this.total = res.total;
        this.service_list = res.data;
      });
    }
  },
  components: {}
};
</script>

<style scoped lang="scss">
.service {
  .info_box {
    background-color: #fff;

    .order_list_item {
      &:nth-of-type(1) {
        width: 260px;
      }

      width: 175px;
    }

    .order-list {
      .order-item {
        border: 1px solid #e5e5e5;

        .order_list_item {
          border-right: 1px solid #e5e5e5;

          &:nth-of-type(4) {
            border-right: none;
          }
        }

        .top {
          background-color: #f0f6ff;
          padding: 14px;
        }

        .middle {
          .order {
            .order_left {
              min-height: 80px;
              border-right: 1px solid #e5e5e5;
              border-bottom: 1px solid #e5e5e5;

              &:last-child {
                border-bottom: none;
              }

              .goods_img {
                width: 80px;
                height: 80px;
              }
            }

            .operating {
              .el-button {
                font-weight: normal;
              }

              p {
                margin-top: 10px;

                &:nth-of-type(1) {
                  margin-top: 0;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/me/technician/index.vue